import React, { useEffect, useRef, useState } from "react";

import {
  RideGlMoneySolid,
  RideIconButton,
  RideGlDown,
} from "@rimac-seguros/ride-system-components";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";

import { usePlansContext } from "../../../context/PlansContext";
import { formatAmountThousand } from "@/utils/Utils";
import loadingAnimated from "@/assets/animation/loading-animated.json";

import "./styles.scss";

export const DetailPlanMobile = () => {
  const [open, setOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);

  const { typeOfFinancing, planSelected } = useSelector((state) => state.plans);
  const { isLoadingData } = usePlansContext();
  const contentRef = useRef(null);
  const lottieRef = useRef();

  const { devolucionTotal, gananciaTotal, aporteTotal } = typeOfFinancing || {};
  const { savingTime, returnPercentage } = planSelected || {};

  useEffect(() => {
    if (isLoadingData) {
      setOpen(false);
    }
  }, [isLoadingData]);

  useEffect(() => {
    if (open && contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [open, returnPercentage]);

  useEffect(() => {
    if (lottieRef) {
      lottieRef.current.setSpeed(1.5);
    }
  }, [lottieRef]);

  return (
    <div className="relative col-span-full lg:hidden">
      <div className="flex items-center justify-between pt-ride-gl-spacing-large pb-ride-gl-spacing-xlarge">
        <div className="relative flex items-center w-full gap-ride-gl-spacing-large">
          <RideGlMoneySolid size="x-large" className="footer-action-icon" />
          <div className="ride-sys-text-paragraph-medium-regular-short">
            En {savingTime?.text} años recibirás
            <span className="ml-2 ride-sys-text-paragraph-large-bold-short">
              {isLoadingData ? (
                <Lottie
                  lottieRef={lottieRef}
                  animationData={loadingAnimated}
                  autoplay
                  className="detail-plan-mob_animated-amount"
                />
              ) : (
                <>
                  S/
                  {formatAmountThousand(
                    Number(devolucionTotal || 0).toFixed(2)
                  )}
                </>
              )}
            </span>
          </div>
        </div>
        <RideIconButton
          glyph={<RideGlDown />}
          variant="outline"
          size="small"
          className={`${
            open ? "transform rotate-180 transition-all delay-75" : ""
          }`}
          onClick={() => {
            if (!isLoadingData) {
              setOpen(!open);
            }
          }}
        />
      </div>
      <div
        className="overflow-hidden transition-all"
        style={{
          height: open ? `${contentHeight}px` : "0px",
        }}
      >
        <div
          ref={contentRef}
          className="flex flex-col pt-ride-gl-spacing-xlarge pb-ride-gl-spacing-large gap-ride-gl-spacing-medium border-t-ride-gl-border-width-thin border-ride-sys-color-border-default"
        >
          <div className="flex justify-between ride-sys-text-paragraph-medium-regular-short">
            <span>
              Ganancia extra
              {returnPercentage?.text === "100%" && (
                <span className="block ride-sys-text-paragraph-small-default">
                  (Eligiendo desde un 115% de devolución)
                </span>
              )}
            </span>
            <span>
              S/{formatAmountThousand(Number(gananciaTotal || 0).toFixed(2))}
            </span>
          </div>
          <div className="flex justify-between ride-sys-text-paragraph-medium-regular-short">
            <span>Aporte total</span>
            <span>
              S/{formatAmountThousand(Number(aporteTotal || 0).toFixed(2))}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
